import React from "react";
import { inject, observer } from "mobx-react";
import { Message, useMessage, useMessageGetter } from "react-message-context";
import { Button, ButtonRow } from "@op/opds.opux";
import { Modal } from "@op/opds.opux-modal";
import { reaction } from "mobx";

const DataDeletedModal = observer(({ SessionStore, FeedbackStore }) => {
  const { showDataDeletedModal, dataDeletedWithAcknowledgement } = SessionStore;
  const msgs = useMessageGetter("session.dataDeleted.modal");
  const redirectUrl = useMessage("url.form.unidentified")();

  reaction(
    () => SessionStore.showDataDeletedModal,
    () => FeedbackStore.reset()
  );

  const createFooter = () => (
    <ButtonRow className="rof-modal__footer">
      <Button id="ROF-dataDeleted-close" compact href={redirectUrl}>
        {msgs("close")}
      </Button>
    </ButtonRow>
  );

  return (
    <Modal
      id="ROF-dataDeleted"
      footer={createFooter()}
      isOpen={showDataDeletedModal}
      onUpdate={(state) => {
        SessionStore.showDataDeletedModal = state.open;
      }}
      title={msgs("title")}
      appElement={document.getElementById("reportproblemopfi-main")}
    >
      <div className="opux-v6__opds">
        <p>
          <Message
            id={`session.dataDeleted.modal.text.${
              dataDeletedWithAcknowledgement ? "b" : "a"
            }`}
          />
        </p>
      </div>
    </Modal>
  );
});

export default inject("SessionStore", "FeedbackStore")(DataDeletedModal);
